import React, { useRef, useState, useEffect } from 'react';
import { GridWrapper, GridItem, SearchInput, CheckboxField, FormGroup, SelectField, Card, List, ListItem, Alert, Container } from '@sainsburys-tech/luna-react';
import TilesInfoApi from '../../../api/tilesInfoApi';
import { useApiClient } from '../../../context/AppContext';

interface Tile {
  title: string;
  currentCount: number;
  previousCount: number;
  previousLabel: string;
}

interface AverageTile {
  averageRiskScore: number;
  averageRiskCount: number;
}

const Tiles = () => {
  const apiClient = useApiClient();
  const [tiles, setTiles] = useState<Tile[]>([]);
  const [avgTiles, setAvgTiles] =  useState<AverageTile>({ averageRiskScore: 0, averageRiskCount: 0 });
  const [errorAlert, setErrorAlert] = useState<false | string>(false)


  useEffect(() => {
    const tiledata = async () => {
      await loadtilesdata();
    };
    tiledata();
  }, []);

  const loadtilesdata = async (): Promise<void> => {
    try {
      const response = await TilesInfoApi.getRiskWOTilesData(apiClient);
      if (response && response[0]) {
        const data = response[0];
        const tiles = [
          {
            title: "Today",
            currentCount: data.todayTile?.todayCount || 0,
            previousCount: data.todayTile?.lastWeekCount || 0,
            previousLabel: "last week"
          },
          {
            title: "This Week",
            currentCount: data.thisWeekTile?.thisWeekCount || 0,
            previousCount: data.thisWeekTile?.lastWeektoDateCount || 0,
            previousLabel: "last week"
          },
          {
            title: "This Period",
            currentCount: data.thisPeriodTile?.thisPeriodCount || 0,
            previousCount: data.thisPeriodTile?.lastPeriodCount || 0,
            previousLabel: "last period"
          }
        ];
        const avgTiles = {
          averageRiskScore: data.averageRiskTile?.averageRiskScore || 0,
          averageRiskCount: data.averageRiskTile?.averageRiskCount || 0
        }
        setTiles(tiles);
        setAvgTiles(avgTiles);
      } else {
        setErrorAlert('No data available')
      }
    } catch (error) {
      console.log(error);
      setErrorAlert('Something went wrong!')
    }
  };

  return (
    <>
      {tiles.map((tile, index) => (
        <GridItem key={index} size={{ sm: '1/4', default: '1/2' }} style={{ marginTop: "10px", textAlign: 'center', alignItems: "center" }}>
          <Card
            className="cb-c-alert-list-item__drop-shadow cb-c-alert-list-item tiles_card"
            style={{ height: '120px', backgroundColor: 'rgb(240, 108, 0)', color: 'white', width: '100%', margin: '0', padding: '10px' }}
          >
            <div className="ln-u-display-4-fixed cb-c-alert-list-item__value cb-u-text-align-center-responsive">
              <div className="row1">
                {tile.title}
              </div>
              <div className="row2">
                <h1>{tile.currentCount}</h1>
                <h3>VS {tile.previousCount}</h3>
              </div>
              <div className="row3">
                {tile.previousLabel}
              </div>
            </div>
          </Card>
        </GridItem>
      ))}
      <GridItem key="averageRisk" size={{ sm: '1/4', default: '1/2' }} style={{ marginTop: "10px", textAlign: 'center', alignItems: "center" }}>
        <Card
          className="cb-c-alert-list-item__drop-shadow cb-c-alert-list-item tiles_card"
          style={{ height: '120px', backgroundColor: 'rgb(240, 108, 0)', color: 'white', width: '100%', margin: '0', padding: '10px' }}
        >
          <div className="ln-u-display-4-fixed cb-c-alert-list-item__value cb-u-text-align-center-responsive">
            <div className="row1">
              Average Risk
            </div>
            <div className="row">
              <h1>{avgTiles.averageRiskScore}</h1>
              <h3>Top {avgTiles.averageRiskCount}</h3>
            </div>
          </div>
        </Card>
      </GridItem>
    </>
  );
}

export default Tiles;